import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aviso_privacidad',
  templateUrl: './aviso_privacidad.component.html',
  styleUrls: ['./aviso_privacidad.component.css']
})
export class Aviso_privacidadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
